import { render, staticRenderFns } from "./AddSaleOrder.vue?vue&type=template&id=2428922b&scoped=true&"
import script from "./AddSaleOrder.vue?vue&type=script&lang=js&"
export * from "./AddSaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./AddSaleOrder.vue?vue&type=style&index=0&id=2428922b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428922b",
  null
  
)

export default component.exports